import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-form-edit-complex',
    templateUrl: './form-edit-complex.component.html',
    styleUrls: ['./form-edit-complex.component.scss'],
    standalone: false
})
export class FormEditComplexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
